<template>
  <div :class="[ line ? 'grid gap-6 grid-cols-4' : 'flex flex-col']">
    <SkeletonElementImage class="h-60" />
    <div class="mb-4" :class="{ 'order-3': line }">
      <div class="flex flex-col justify-center h-14">
        <div class="h-5"></div>
      </div>
      <div class="flex flex-col items-center gap-1">
        <div class="h-12 w-20 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        <div class="h-4 w-16 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        <div class="h-4 w-24 bg-gray-200 rounded-full dark:bg-gray-700"></div>
      </div>
    </div>

    <div :class="{ 'order-2 col-span-2': line }">
      <div class="h-6 bg-gray-200 rounded-full dark:bg-gray-700 w-100 mb-6"></div>

      <div class="flex flex-col items-center gap-1">
        <div class="h-4 w-36 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        <div class="h-4 w-full bg-gray-200 rounded-full dark:bg-gray-700"></div>
        <div class="h-4 w-24 bg-gray-200 rounded-full dark:bg-gray-700"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  line?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  line: false,
});
</script>